module.exports = __webpack_public_path__ + "img/Mask-group4.e77d8969.png";